import { useLocalization } from '@/Hooks';
import { userSelectors } from '@/Redux/User';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { DateFormatType } from '@/Enums';
import { formDateInputUtils } from '@/Components/Controls/DateInput/utils';

export const useDaterangePickerLocale = (needTimePicker: boolean, needInputMask: boolean) => {
  const {
    buttons,
    enums: { DateRangeType },
    common: { DaysOfWeek, Months },
  } = useLocalization();

  const { timeFormat, dateFormat, firstDayOfWeek } = useSelector(userSelectors.regionalSettings);

  return useMemo(() => {
    const timePart = needTimePicker ? formDateInputUtils.normalizeTimeFormat(timeFormat?.value) : '';
    const datePart = needInputMask ? formDateInputUtils.normalizeDateFormat(dateFormat?.value) : dateFormat?.value;

    return {
      customRangeLabel: DateRangeType.Custom,
      cancelLabel: buttons.Clear,
      applyLabel: buttons.Ok,
      firstDay: Number(firstDayOfWeek?.value ?? 1),
      format: `${datePart} ${timePart}` as DateFormatType,
      daysOfWeek: [
        DaysOfWeek.Sunday,
        DaysOfWeek.Monday,
        DaysOfWeek.Tuesday,
        DaysOfWeek.Wednesday,
        DaysOfWeek.Thursday,
        DaysOfWeek.Friday,
        DaysOfWeek.Saturday,
      ],
      monthNames: [
        Months.January,
        Months.February,
        Months.March,
        Months.April,
        Months.May,
        Months.June,
        Months.July,
        Months.August,
        Months.September,
        Months.October,
        Months.November,
        Months.December,
      ],
    };
  }, [buttons, DaysOfWeek, Months, timeFormat, dateFormat, firstDayOfWeek, needTimePicker]);
};
